import React, { useEffect, useState } from "react";
import { Row, Typography, Table, Tooltip } from "antd";

import { fetchInaamCustomerListApi } from "utils/apiService";

const { Text } = Typography;

export default function DataTable(props) {
	const [loading, setLoading] = useState(false);
	const [tableLoading, setTableLoading] = useState(true);

	const [pageDetails, setPageDetails] = useState({
		pageSize: 1,
		totalPages: 1,
	});
	const [pageNum, setPageNum] = useState(1);

	const exportReportDate = props.customerDetailsFilterDate;

	const [customerList, setCustomerList] = useState([]);

	const fetchInaamCustomerList = () => {
		setLoading(true);
		fetchInaamCustomerListApi({
			requestData: { ...exportReportDate, page: pageNum },
			resCallback: () => {
				loading && setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				let customerList_copy = res.data.customer_list.map((customer, index) => ({ ...customer, key: index }));
				pageNum === 1 && setPageDetails({ pageSize: res.data.customer_list.length, totalPages: res.data.total_pages });
				setCustomerList(customerList_copy);
			},
		});
	};

	const handlePageChange = (pagination) => {
		setPageNum(pagination.current);
	};

	useEffect(() => fetchInaamCustomerList(), [pageNum,exportReportDate]);

	const columns = [
		{
			title: "Phone Number",
			dataIndex: "contact_number",
			key: "contact_number",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818" }}>{data ? data : "-"}</Text>
				);
			},
		},
		{
			title: "Customer Name",
			dataIndex: "customer_name",
			key: "customer_name",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "bold", fontSize: "16px", lineHeight: "24px", color: "#181818" }}>{data ? data : "-"}</Text>
				);
			},
		},
		{
			title: "Card No",
			dataIndex: "card_number",
			key: "card_number",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", width: "10%", color: "#747474" }}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
		{
			title: "Gender",
			dataIndex: "gender",
			key: "gender",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
		{
			title: (
				<Tooltip placement="bottomLeft" title={<Text>Vouchers Claimed/Generated</Text>}>
					Vouchers
				</Tooltip>
			),
			dataIndex: ["vouchers_generated, vouchers_used"],
			key: "voucher",
			render: (text, row) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
						{`${row["vouchers_used"]}/${row["vouchers_generated"]}`}
					</Text>
				);
			},
		},
		{
			title: "Promos",
			dataIndex: "promotion",
			key: "promotion",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
		{
			title: "Joined On",
			dataIndex: "joined_on",
			key: "joined_on",
			render: (data) => {
				return (
					<Text style={{ fontStyle: "normal", fontWeight: "normal", fontSize: "14px", lineHeight: "22px", color: "#747474" }}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
	];

	return (
		<>
			<Row type="flex" justify="space-between" style={{ height: "max-content", alignItems: "center" }}>
				<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "18px", lineHeight: "24px" }}>
					Customer Details
				</Text>
			</Row>
			<Table
				pagination={{ showQuickJumper: true, current: pageNum, pageSize: pageDetails.pageSize, total: pageDetails.pageSize * pageDetails.totalPages }}
				onChange={(pagination) => {
					handlePageChange(pagination);
				}}
				columns={columns}
				dataSource={customerList}
				loading={tableLoading}
			/>
		</>
	);
}
